var _excluded = ["isOpen", "icon", "isFullScreen", "variant", "isLoading", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { FloatingOverlay } from '@floating-ui/react';
import { useCallback } from 'react';
import { Icon } from '../../../foundations/Icon';
import { Loader } from '../../../foundations/Loader';
import { Fade } from '../../../foundations/transitions';
import { zIndices } from '../../../theme/foundations';
import { forwardRef } from '../../../utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { Box } from '../../internal';
/**
 * @private For internal use only
 */
// eslint-disable-next-line @typescript-eslint/naming-convention

import { jsx as _jsx } from "react/jsx-runtime";
export var fadeStyle = {
  zIndex: zIndices.docked,
  inset: 0
};
/**
 * @private For internal use only
 */
// eslint-disable-next-line @typescript-eslint/naming-convention

export var Blanket = forwardRef((_ref, ref) => {
  var {
    isOpen = false,
    icon,
    isFullScreen,
    variant,
    isLoading,
    onClick
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var styles = useMultiStyleConfig('Blanket', {
    variant: variant !== null && variant !== void 0 ? variant : isFullScreen ? 'darker' : 'dark',
    isFullScreen,
    isLoading
  });
  var handleClose = useCallback(() => {
    if (!isFullScreen) return;
    if (onClick) onClick(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFullScreen]);
  return /*#__PURE__*/_jsx(Fade, {
    in: isOpen,
    unmountOnExit: true,
    transition: {
      enter: {
        duration: 0.1
      },
      exit: {
        duration: 0.1
      }
    },
    style: _objectSpread(_objectSpread({}, fadeStyle), {}, {
      position: isFullScreen ? 'fixed' : 'absolute'
    }),
    children: /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread(_objectSpread({
      "data-component": "Blanket",
      __css: styles['container'],
      ref: ref
    }, props), {}, {
      onClick: handleClose // Leveraging `FloatingOverlay` to lock scroll when `isFullScreen`.

    }, isFullScreen && {
      as: FloatingOverlay,
      lockScroll: true
    }), {}, {
      children: isLoading ? /*#__PURE__*/_jsx(Loader, {
        "data-testid": "loader",
        color: variant !== 'light' ? 'neutral.white' : undefined
      }) : icon && /*#__PURE__*/_jsx(Box, {
        __css: styles['icon'],
        children: /*#__PURE__*/_jsx(Icon, {
          type: icon,
          color: variant === 'light' ? 'default' : 'inverted'
        })
      })
    }))
  });
});
Blanket.displayName = 'Blanket';
//# sourceMappingURL=Blanket.js.map